import { useState } from 'react';
import { RgbaColorPicker } from 'react-colorful';
import './style.scss';
import InputWrap from '../../../../../components/InputWrap';

const rgbaToHex = ({ r, g, b, a }: { r: number; g: number; b: number; a: number }) => {
  const toHex = (value) => value.toString(16).padStart(2, '0');
  const alphaHex = a < 1 ? toHex(Math.round(a * 255)) : '';
  return `#${toHex(r)}${toHex(g)}${toHex(b)}${alphaHex}`;
};

const hexToRgba = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  const a = hex.length === 9 ? parseInt(hex.slice(7, 9), 16) / 255 : 1;
  return { r, g, b, a };
};

interface RgbaColorPickerCustomProps {
  onHexColorChange: (hexColor: string) => void;
  defaultValue?: string;
}
const RgbaColorPickerCustom: React.FC<RgbaColorPickerCustomProps> = ({ onHexColorChange, defaultValue }) => {
  const [hexColor, setHexColor] = useState(defaultValue);
  const [rgbaColor, setRgbaColor] = useState(() =>
    defaultValue ? hexToRgba(defaultValue) : { r: 0, g: 0, b: 0, a: 1 },
  );
  const handleRgbaChange = (newRgbaColor: { r: number; g: number; b: number; a: number }) => {
    const newHexColor = rgbaToHex(newRgbaColor);
    setHexColor(newHexColor);
    setRgbaColor(newRgbaColor);
    onHexColorChange(newHexColor);
  };
  return (
    <div className="color">
      <RgbaColorPicker className="color-picker" color={rgbaColor} onChange={handleRgbaChange} />

      <div className="color-label">
        <InputWrap
          type="text"
          value={hexColor}
          onChange={(e) => {
            const newHexColor = e.target.value;
            const newRgbaColor = hexToRgba(newHexColor);
            setHexColor(newHexColor);
            setRgbaColor(newRgbaColor);
            onHexColorChange(newHexColor);
          }}
          className="color-input"
        />
      </div>
    </div>
  );
};

export default RgbaColorPickerCustom;
